// Option C PR 3 (2026-10-11): the one list of chart-page ids. App.vue's
// route resolver used to keep its own copy (validChartIds) next to the
// ChartId union in ChartBreadcrumbs.vue; both now derive from this array.
export const CHART_IDS = [
  'bgavsnas', 'bgavskt', 'bgavskt-intraday', 'vix', 'vixregime', 'gbpusd', 'sentiment', 'cusum',
  'gold-gvz', 'gold-kt', 'gold-xau', 'gold-10y', 'goldvsgc',
  'jhvsnas', 'jhvsbga', 'jhvskt', 'jhvskt-intraday',
  'ggevscl',
  'pnl-bga', 'pnl-jh', 'pnl-gold', 'pnl-gge', 'pnl-japan', 'pnl-charteris', 'pnl-amati', 'pnl-miners', 'pnl-japanesg', 'pnl-tech', 'pnl-electrum', 'pnl-jhtech', 'pnl-asiatech', 'pnl-baringsoil', 'pnl-spworld', 'pnl-smallcap', 'pnl-total',
  'japanvsniy', 'japanvstopix', 'gbpjpy',
  'charterisvssi',
] as const

export type ChartId = typeof CHART_IDS[number]

export function isChartId(s: string): s is ChartId {
  return (CHART_IDS as readonly string[]).includes(s)
}
